mtl.alloy.factory['quote-delivery'] = (function($) {
    'use strict';

    return function(element, options) {
        $(element).on('submit', function(e){
            e.preventDefault();

            $.ajax({
                url: $(this).attr('action'),
                data: $(this).serialize()+'&location='+encodeURIComponent(window.location.pathname),
                cache: false,
                success: function(jsonContent){
                    if(typeof jsonContent.deliveryPrices.standard != 'undefined') {
                        $(element).html('Our standard delivery to '+$('input[name="postcode"]').val().toUpperCase()+' starts at '+currencyFormat(jsonContent.deliveryPrices.standard/100));
                    } else {
                        alert('No delivery prices could be found');
                    }
                },
            });
        });
    }

}($));
